import script from "./VNumericQuarterTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./VNumericQuarterTable.vue?vue&type=script&setup=true&lang=ts"

import "./VNumericQuarterTable.vue?vue&type=style&index=0&id=e25e2f36&lang=scss"

const __exports__ = script;

export default __exports__